<template>
  <li
    v-if="member"
    class="member p-3">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center flex-grow-1">
        <div>
          <img
            v-if="member.avatar"
            class="img-fluid rounded-circle member__img mr-3"
            :src="member.avatar">
          <p v-else>
            <span class="material-icons member__icon mr-3">person</span>
          </p>
        </div>
        <div
          class="member__content d-flex flex-grow-1 align-items-center"
          :class="{searched: isSearched}">
          <p class="member__name mr-3">
            {{ member.name }}
          </p>
          <p
            class="member__title">
            {{ member.position }}
          </p>
        </div>
      </div>
      <big-check-box
        :id="member.id"
        :checked="checked"
        :disabled="isCheckedDepartment"
        @input="onCheckedMember" />
    </div>
  </li>
</template>

<script>
import BigCheckBox from '@/components/parts/BigCheckBox.vue'

export default {
  components: {
    BigCheckBox
  },
  props: {
    member: {
      type: Object,
      required: true
    },
    isCheckedMember: {
      type: Boolean,
      required: true
    },
    isCheckedDepartment: {
      type: Boolean,
      required: true
    },
    isSearched: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked() {
      // メンバーが個別にチェックされている or 所属グループ自体がチェックされている
      return this.isCheckedMember || this.isCheckedDepartment
    }
  },
  methods: {
    onCheckedMember() {
      this.$emit('member-checked', this.member.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.member__content {
  margin-right: 15px;
  margin-left: -5px;
  border-radius: 5px;
  padding: 5px 10px;

  &.searched {
    background: $highlight;
  }
}

.member__title {
  margin-left: auto;
}
</style>